/**
 * compares the supplied arrays
 *
 * @param a
 * @param b
 * @param options {@link options}
 */
export function notEqual<T>(
  a: null | undefined | T[],
  b: null | undefined | T[],
  options?: {
    /**
     * an {@link Array.sort} compareFn to help {@link JSON.stringify} properly
     * sort {@link a} and {@link b}
     */
    compareFn?: (A: T, B: T) => number
  }
): boolean
/**
 * compares the supplied generic values
 *
 * @param a
 * @param b
 * @param options {@link options}
 */
export function notEqual<T>(
  a: null | undefined | T,
  b: null | undefined | T,
  options?: {
    /**
     * a callback to transform the value into something else
     *
     * this can be helpful if {@link JSON.stringify} doesn't make
     * {@link a} and {@link b} similar enough to compare equality (i.e. Moment, Date)
     *
     * @param value
     */
    transform?: (value: T) => any
  }
): boolean
// implementation
export function notEqual<T>(
  a: null | undefined | T | T[],
  b: null | undefined | T | T[],
  options?: {
    compareFn?: (a: T, b: T) => number
    transform?: (value: T) => any
  }
) {
  const { compareFn, transform } = options ?? {}
  if (!a && !b) return false
  else if (!a) return true
  else if (!b) return true

  if (Array.isArray(a) && Array.isArray(b)) {
    const stringify = (ts: T[]) => JSON.stringify([...ts].sort(compareFn))
    const A = stringify(a)
    const B = stringify(b)
    return A !== B
  } else if (Array.isArray(a)) return true
  else if (Array.isArray(b)) return true

  const stringify = (t: T) => JSON.stringify(transform?.(t) ?? t)
  const A = stringify(a)
  const B = stringify(b)
  return A !== B
}
